import React from 'react';

import type { BaseCardProps } from '../types';

const CardImage: React.FC<Pick<BaseCardProps, 'image' | 'fallbackIllustration'>> = (props) => {
  const { image, fallbackIllustration } = props;

  return (
    <div className="Card__image">
      {image && typeof image !== 'string' && image}
      {typeof image === 'string' && <img src={image} alt="" />}
      {!image && fallbackIllustration && (
        <img className="Card__image__fallback" src={fallbackIllustration} alt="" />
      )}
    </div>
  );
};

export default CardImage;
